import { createSlice } from "@reduxjs/toolkit";

export const rightsSlice = createSlice({
  name: "rights",
  initialState: ["ADMIN"],
  reducers: {
    updateRights: (state, action) => {
      return [...state, ...action?.payload];
    },
    resetRights: (state, action) => {
      return ["ADMIN"];
    },
  },
});

export const { updateRights, resetRights } = rightsSlice.actions;
export default rightsSlice.reducer;
